export default __webpack_public_path__ + "static/media/logo-text.87e3e030.png";